import { ReactNode } from 'react';
import { FlexAlignType, StyleProp, View, ViewStyle } from 'react-native';

import { spacing } from '@/constants/theme';

type SpacingToken = keyof typeof spacing;

type Justify =
  | 'flex-start'
  | 'center'
  | 'flex-end'
  | 'space-between'
  | 'space-around'
  | 'space-evenly';

export type InlineProps = {
  children: ReactNode;
  /** Gap between children, mapped to `theme.spacing[token]`. Default `'base'` (16). */
  gap?: SpacingToken;
  /** Cross-axis alignment. Default `'center'` — matches typical icon+label rows. */
  align?: FlexAlignType;
  justify?: Justify;
  /** Allow children to wrap to next line. Default false. */
  wrap?: boolean;
  flex?: number;
  style?: StyleProp<ViewStyle>;
  testID?: string;
};

export function Inline({
  children,
  gap = 'base',
  align = 'center',
  justify,
  wrap = false,
  flex,
  style,
  testID,
}: InlineProps) {
  return (
    <View
      style={[
        {
          flexDirection: 'row',
          flexWrap: wrap ? 'wrap' : 'nowrap',
          gap: spacing[gap],
          alignItems: align,
          justifyContent: justify,
          flex,
        },
        style,
      ]}
      testID={testID}
    >
      {children}
    </View>
  );
}
